import type { FAQItem, ResourcePageSeo } from "../resource-seo";

export const faqs: FAQItem[] = [
  {
    question: "What is the MindMyJob Layoffs Tracker?",
    answer:
      "A running list of layoffs and hiring freezes across tech companies. Each entry shows the company, the number of roles affected, the teams involved, the date and a link to the source.",
  },
  {
    question: "Where does the layoff data come from?",
    answer:
      "From public sources such as company announcements, regulatory filings and news reports. Every entry links to its source so you can check it yourself.",
  },
  {
    question: "How often is the tracker updated?",
    answer: "New events are added as they are reported, usually the same day.",
  },
  {
    question: "What does a company's health status mean?",
    answer:
      "It combines recent layoffs, hiring freezes, the trend in open roles and funding news into one of three statuses: Healthy, Watch or At risk. It is a quick signal, not a prediction, so read the details before deciding.",
  },
  {
    question: "Can I get alerts for companies I'm interested in?",
    answer:
      "Yes. Add companies to your watchlist and choose what to be told about: layoffs, hiring freezes, new matching roles or funding news.",
  },
  {
    question: "Can I hide jobs from companies with recent layoffs?",
    answer:
      "Yes. Turn on the hiring-health filter on the job board to hide those jobs, or leave it off and see a warning badge on the listing instead.",
  },
  {
    question: "Should I avoid every company that has had layoffs?",
    answer:
      "Not always. A company may cut one team and keep hiring in another. Check which teams were affected and whether roles like yours are still open before ruling a company out.",
  },
];

export const seo: ResourcePageSeo = {
  slug: "layoffs-tracker",
  name: "Layoffs Tracker",
  title: "Tech Layoffs Tracker and Hiring Freezes | MindMyJob",
  description:
    "Track tech layoffs and hiring freezes as they happen, check a company's hiring health before you apply and get alerts for companies you follow.",
  keywords: [
    "tech layoffs tracker",
    "layoffs 2026",
    "india tech layoffs",
    "hiring freeze list",
    "companies laying off",
    "is this company hiring",
    "company health check",
    "startup layoffs",
    "layoff alerts",
    "companies still hiring",
  ],
  ogImage: "/assets/images/resources/layoffs-tracker/hero-layoffs-feed.png",
  ogImageAlt:
    "MindMyJob Layoffs Tracker feed showing recent tech layoffs with roles affected and sources",
  featureList: [
    "Layoffs feed with sources",
    "Filters by region, industry and team",
    "Company health status",
    "Watchlist alerts",
    "Hiring-health filter on the job board",
  ],
  faqs,
};
